<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">发布公告</p>
				</div>
				<div class="notice">
					<div class="notice_list mab30">
						<div class="notice_list_l f16px cl_dark">公告标题</div>
						<div class="notice_list_r">
							<input type="text" v-model="name" class="notice_list_input f16px" placeholder="输入公告标题" />
						</div>
					</div>
					<div class="notice_list mab30">
						<div class="notice_list_l f16px cl_dark">接收对象</div>
						<div class="notice_list_r">
							<button class="notice_list_object f14px cl_violet" @click="innerVisible=true">添加接收对象</button>
							<div class="notice_list_class_cont mat20" v-if="class_check.length > 0">
								<div class="notice_list_class" v-for="(item,index) in class_check" :key="index">{{item.name}}</div>
							</div>
						</div>
					</div>
					<div class="notice_list">
						<div class="notice_list_l f16px cl_dark">公告内容</div>
						<div class="notice_list_r">
							<textarea v-model="content" class="notice_list_area f16px" placeholder="输入公告标题" ></textarea>
						</div>
					</div>
					<div class="notice_list">
						<button class="f18px cl_white notice_submit" @click="submit">提交</button>
					</div>
				</div>
			</div>
		</div>
		<!-- 布置对象 -->
		<el-dialog width="35%" title="添加布置对象" center :visible.sync="innerVisible">
			<div class="class_dialog_nav flex">
				<div class="class_dialog_nav_l flex f18px cl_dark">
					<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'normal_grade_data'}"
					@click="class_cur = 'normal_grade_data'">行政班</span>
					<span class="class_dialog_nav_list cur" :class="{'on': class_cur == 'tutor_grade_data'}"
					@click="class_cur = 'tutor_grade_data'">教学班</span>
				</div>
				<div class="cl_red">*行政班与教学班不可同时布置</div>
			</div>
			<div class="class_dialog_cont cl_dark f16px">
				<div class="class_dialog_list" v-show="class_cur == 'normal_grade_data'">
					<div v-for="(item,index) in class_data.normal_grade_data" :class="index">
						<div class="mat20 mab20">{{item.gradeName}}</div>
						<div class="class_dialog_list_cont tc">
							<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
							:class="{'on':item.check}" @click="normalCheck(index,secondIndex)">{{item.name}}</div>
						</div>
					</div>
				</div>
				<div class="class_dialog_list" v-show="class_cur == 'tutor_grade_data'">
					<div v-for="(item,index) in class_data.tutor_grade_data" :class="index">
						<div class="mat20 mab20">{{item.gradeName}}</div>
						<div class="class_dialog_list_cont tc">
							<div class="cur radius8 class_dialog_list_item" v-for="(item,secondIndex) in item.class_data" :key="secondIndex"
							:class="{'on':item.check}" @click="tutorCheck(index,secondIndex)">{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="class_dialog_btm tc mat40">
				<button class="f18px cl_violet radius20 bg_white mar10 class_dialog_cancel" @click="innerVisible = false">取消</button>
				<button class="f18px cl_white radius20 mal10 class_dialog_confirm" @click="classSubmit()">确定</button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 3,
					listCur: 0,
					open: 0,
				},
				name: "",
				content: "",
				innerVisible: false,
				class_cur: "normal_grade_data",
				class_data: {},
				class_cur: "",
				class_check: [],
			}
		},
		created() {
			
		},
		mounted() {
			this.getClass();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			getClass () {
				this.$get("/api/teacher/get_assign_homework_class",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					for (let i = 0; i < res.data.normal_grade_data.length; i ++) {
						for (let j = 0; j < res.data.normal_grade_data[i].class_data.length; j++) {
							res.data.normal_grade_data[i].class_data[j].check = false;
						}
					}
					for (let k = 0; k < res.data.tutor_grade_data.length; k ++) {
						for (let l = 0; l < res.data.tutor_grade_data[k].class_data.length; l++) {
							res.data.tutor_grade_data[k].class_data[l].check = false;
						}
					}
					this.class_data = res.data;
					this.class_cur = "normal_grade_data";
				});
			},
			normalCheck (index,secondIndex) {
				if (this.class_data.normal_grade_data[index].class_data[secondIndex].check) {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.normal_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			tutorCheck (index,secondIndex) {
				if (this.class_data.tutor_grade_data[index].class_data[secondIndex].check) {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = false;
				} else {
					this.class_data.tutor_grade_data[index].class_data[secondIndex].check = true;
				}
			},
			classSubmit () {
				var arr = [];
				if (this.class_cur == "normal_grade_data") {
					for (let i = 0; i < this.class_data.normal_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.normal_grade_data[i].class_data.length; j++) {
							if (this.class_data.normal_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.normal_grade_data[i].class_data[j])
							}
						}
					}
				} else {
					for (let i = 0; i < this.class_data.tutor_grade_data.length; i ++) {
						for (let j = 0; j < this.class_data.tutor_grade_data[i].class_data.length; j++) {
							if (this.class_data.tutor_grade_data[i].class_data[j].check) {
								arr.push(this.class_data.tutor_grade_data[i].class_data[j])
							}
						}
					}
				}
				this.class_check = arr;
				this.innerVisible = false;
			},
			submit () {
				if (this.name == "") {
					this.$message({
						type: 'warning',
						message: '请填写公告标题',
						duration: 1500,
					});
					return false
				}
				if (this.content == "") {
					this.$message({
						type: 'warning',
						message: '请填写公告内容',
						duration: 1500,
					});
					return false
				}
				if (this.class_check.length == 0) {
					this.$message({
						type: 'warning',
						message: '请选择布置对象',
						duration: 1500,
					});
					return false
				}
				let class_id_str = [];
				for (let i = 0; i < this.class_check.length; i++) {
					class_id_str.push(this.class_check[i].id);
				}
				class_id_str = class_id_str.join(",");
				this.$get("/api/teacher/post_notice_add",{
					token: localStorage.getItem("token"),
					name: this.name,
					content: this.content,
					class_id_str: class_id_str,
				})
				.then(res => {
					this.$message({
						duration: 1500,
						message: res.msg,
						type: 'success'
					});
					setTimeout(() => {
						location.reload();
					}, 1500);
				});
			},
		},
	}
</script>

<style>
</style>
